(() => {
  if (customElements.get('extro-cart-progress')) return;
  class CartProgress extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const info = this.querySelector('.ec-delivery-info');
      const button = info?.querySelector('button');
      const tooltip = info?.querySelector('[role="tooltip"]');
      if (button && tooltip) {
        const options = { signal: this.controller.signal };
        const show = visible => { tooltip.hidden = !visible; button.setAttribute('aria-expanded', String(visible)); };
        info.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') show(true); }, options);
        info.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') show(false); }, options);
        button.addEventListener('focus', () => { if (button.matches(':focus-visible')) show(true); }, options);
        button.addEventListener('blur', () => show(false), options);
        button.addEventListener('click', event => { if (event.detail) show(tooltip.hidden); else show(true); }, options);
        document.addEventListener('pointerdown', event => { if (!info.contains(event.target)) show(false); }, options);
        document.addEventListener('keydown', event => { if (event.key === 'Escape') show(false); }, options);
      }
      this.threshold = Number(this.dataset.threshold);
      if (!(this.threshold > 0)) return;
      this.total = Number(this.dataset.total) || 0;
      const currency = this.dataset.currency || 'EUR';
      const formatter = new Intl.NumberFormat(currency === 'EUR' ? 'it-IT' : (document.documentElement.lang || 'it'), { style: 'currency', currency });
      this.format = { format: value => currency === 'EUR'
        ? '€' + formatter.formatToParts(value).filter(part => part.type !== 'currency' && part.type !== 'literal').map(part => part.value).join('')
        : formatter.format(value) };
      this.version = 0;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) this.classList.remove('ec-entering');
      else {
        this.addEventListener('animationend', event => {
          if (event.animationName === 'ec-fill-in') this.finishMotion();
        }, {signal:this.controller.signal});
        // Ripiego se il foglio stile arriva dopo la definizione del componente.
        this.arrivalTimer=setTimeout(()=>this.finishMotion(),1200);
      }
      const options = { signal: this.controller.signal, capture: true };
      for (const name of ['cart:updated', 'cart:change', 'cart:refresh', 'ajaxCart.afterCartLoad', 'product-added-to-cart']) {
        document.addEventListener(name, event => {
          const cart = event.detail?.cart;
          if (Number.isFinite(cart?.total_price)) {
            this.version++;
            clearTimeout(this.fetchTimer);
            this.request?.abort();
            this.update(cart.total_price);
          } else this.scheduleRefresh();
        }, options);
      }
      window.addEventListener('pageshow', event => { if (event.persisted) this.scheduleRefresh(); }, options);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.request?.abort();
      clearTimeout(this.fetchTimer); clearTimeout(this.motionTimer); clearTimeout(this.arrivalTimer);
    }
    update(total) {
      total = Math.max(0, total);
      if (this.total === total) return;
      this.total = total;
      const complete = total >= this.threshold;
      const message = this.querySelector('.ec-message');
      message.replaceChildren();
      if (complete) message.textContent = 'Spedizione gratuita · da te in 24-48 ore';
      else if (!total) message.textContent = `Spedizione gratuita da ${this.format.format(this.threshold / 100)}`;
      else {
        const amount = document.createElement('span'); amount.className = 'ec-amount';
        amount.textContent = this.format.format((this.threshold - total) / 100);
        message.append('Completa il tuo outfit: mancano ', amount, ' alla spedizione gratuita');
      }
      this.classList.toggle('is-complete', complete);
      clearTimeout(this.arrivalTimer);clearTimeout(this.motionTimer);
      this.classList.remove('ec-entering','is-celebrating','is-braking');
      this.style.setProperty('--ec-progress', Math.min(total / this.threshold, 1));
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.min(total, this.threshold));
      this.classList.add('is-moving');
      clearTimeout(this.motionTimer);
      this.arrivalTimer = setTimeout(() => this.finishMotion(), 850);
    }
    finishMotion() {
      clearTimeout(this.arrivalTimer);
      this.classList.remove('ec-entering','is-moving','is-braking','is-celebrating');
      if (!this.isConnected || !this.total || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const complete=this.total>=this.threshold;
      this.classList.add(complete?'is-celebrating':'is-braking');
      clearTimeout(this.motionTimer);
      this.motionTimer=setTimeout(()=>this.classList.remove('is-celebrating','is-braking'),1000);
    }
    scheduleRefresh() {
      clearTimeout(this.fetchTimer);
      this.fetchTimer = setTimeout(async () => {
        this.request?.abort();
        this.request = new AbortController();
        const version = ++this.version;
        try {
          const response = await fetch(this.dataset.cartUrl, { signal: this.request.signal, cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (version === this.version && this.isConnected && Number.isFinite(cart.total_price)) this.update(cart.total_price);
        } catch (_) { /* Conserva il totale già mostrato in caso di errore di rete. */ }
      }, 100);
    }
  }
  customElements.define('extro-cart-progress', CartProgress);
})();
